import React from 'react';

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: "The Journey of a Coffee Bean: From Farm to Cup",
      date: "November 15, 2025",
      author: "Funzo Coffee Team",
      image: "/images/Coffee-Roasting.jpg",
      content: "Discover the intricate process that transforms a humble coffee cherry into the aromatic brew you enjoy every morning. From sustainable farming practices in rich volcanic soils to meticulous harvesting and expert roasting, we delve into every step that ensures the highest quality and flavor in your Funzo Coffee.",
    },
    {
      id: 2,
      title: "Sustainability at Funzo Coffee: Our Commitment to the Planet",
      date: "October 28, 2025",
      author: "Environmental Initiative",
      image: "/images/Shade-grown.jpeg",
      content: "At Funzo Coffee, sustainability isn't just a buzzword; it's at the core of everything we do. Learn about our initiatives, including shade-grown coffee, water-smart irrigation, and community programs that support both the environment and our dedicated farmers. Join us in making a positive impact, one cup at a time.",
    },
    {
      id: 3,
      title: "The Art of Coffee Tasting: A Beginner's Guide",
      date: "September 20, 2025",
      author: "Our Head Barista",
      image: "/images/coffee.jpg",
      content: "Ever wondered how coffee experts describe complex flavors like 'notes of chocolate' or 'citrus undertones'? This guide will introduce you to the basics of coffee tasting, helping you identify different aromas, flavors, and body characteristics. Elevate your coffee experience and appreciate the nuances in every sip of Funzo Coffee.",
    },
  ];

  return (
    <div className="container mx-auto px-4 py-10 font-sans text-gray-800">
      <h1 className="text-center text-5xl text-[#4a2c2a] mb-12 relative pb-4">
        Our Blog
        <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-20 h-1 bg-[#a0522d] rounded-md"></span>
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {blogPosts.map((post) => (
          <div key={post.id} className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl flex flex-col">
            <img src={post.image} alt={post.title} className="w-full h-56 object-cover border-b border-gray-200" />
            <div className="p-6 flex flex-col flex-grow">
              <h2 className="text-2xl text-[#4a2c2a] mb-2 leading-tight">{post.title}</h2>
              <p className="text-sm text-gray-600 mb-4">By {post.author} on {post.date}</p>
              <p className="text-base text-gray-700 leading-relaxed mb-5 flex-grow">{post.content}</p>
              <a href={`/blog/${post.id}`} className="inline-block bg-[#a0522d] text-white px-5 py-2 rounded-md font-bold transition-colors duration-300 hover:bg-[#8b4513] self-start">Read More</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
